
// utils/downloadFile.js
export const downloadFile = async (url, filename = "download.xlsx") => {
    try {
        const response = await fetch(url, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch file: ${response.statusText}`);
        }

        // Convert response to Blob
        const blob = await response.blob();
        const href = window.URL.createObjectURL(blob);

        // Create a temporary <a> to trigger download
        const link = document.createElement("a");
        link.href = href;
        link.download = filename;
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(href);
    } catch (err) {
        console.error("Download failed:", err);
    }
};
